import {store} from "../store";
import {getUserTimeZone} from "../libraries/utils";
import appConfig from "../appconfig";
import * as mutationTypes from "../store/mutation-types";
import router from "../router";
import ProductCatalog from "../domains2/products/ProductCatalog";
const TimeBox = appConfig.timeBoxImpl.timebox;
const TimeBoxFormats = appConfig.timeBoxImpl.Formats;

export const loadSingleStepMenu = (product, featureToggles, isKioskChannel) => {
	// Note: this feature is only required on kiosks for now, but we may setup ab test - without checking that explicitly here
	return featureToggles.enableOneStepMenu
					&& featureToggles.moveTopMenuToTheLeftSide
					&& isKioskChannel
					&& product
					&& hasBaseProductWithGroupsAndConfigurations(product);
};

export const loadSingleStepDefault = (product, featureToggles, isKioskChannel) => {
	// Note: this feature is only required on kiosks for now, but we may setup ab test - without checking that explicitly here
	return featureToggles.enableOneStepFlowForSimpleProducts
					&& featureToggles.moveTopMenuToTheLeftSide
					&& isKioskChannel
					&& product
					&& (product.groups.length || product.configurations.length)
					&& product.groups.length <= 1; // Temp fix: We want to exclude products with the many groups i.e. Byg Selv
};

export const hasBaseProductWithGroupsAndConfigurations = (product) => {
	const mainGroup = product.groups.length && product.groups.find(g => g.options.groupType === "main");
	return product.groups.length
	&& mainGroup.products[0]
	&& mainGroup.products[0].groups.length <= 1
	&& mainGroup.products[0].configurations[0]
	&& mainGroup.products[0].configurations[0].options
	&& mainGroup.products[0].configurations[0].options.options
	&& mainGroup.products[0].configurations[0].options.options.length;
};

const isProductLabelRefValid = (labelRef) => {
	return store.getters.tenantSettings.labels && !!store.getters.tenantSettings.labels.find(label => label.key === labelRef);
};
export const isProductBadgeIdValid = (badgeId) => {
	const tenantBadges = store.getters.tenantSettings.productBadges;
	return tenantBadges && !!tenantBadges.find(badge => badge.id === badgeId);
};
export const productHasShortLabel = (product) => {
	return product.options && product.options.productLabelShortText && product.options.productLabelShortText.length;
};
export const productHasLongLabel = (product) => {
	return product.options && product.options.productLabelLongText && product.options.productLabelLongText.length;
};

export const findLabelOverride = (product) => {
	return (product.overrides || []).find(override => {
		return !!(override.type === "labelOverride" && override.shopIds.includes(store.getters.globalSelectedShop.id));
	});
};

export const productHasCustomLabel = (product) => {
	const labelOverride = findLabelOverride(product);
	const {active, labelRef, labelStartDate, labelEndDate} = (((product || {}).options || {}).label || {});
	const dt = new Date();
	dt.setHours(0,0,0,0);
	const renderLabel = (product.options
		&& product.options.label && labelStartDate && labelEndDate && (dt.getTime() >= new Date(labelStartDate).getTime() && dt.getTime() <= new Date(labelEndDate).getTime()));
	return (product.options
		&& product.options.label
		&& active
		&& isProductLabelRefValid(labelRef))
		|| renderLabel
		|| (labelOverride && isProductLabelRefValid(labelRef));
};

export const nutritionalInformation = (product) => {
	router.push({
		name: "nutritionalInformation",
		params: {
			product: product,
			productId: product.id
		}});
};
export const hasFocusProducts = (product) => {
	const labelOverride = findLabelOverride(product);
	if(!store.getters.tenantSettings.labels) {
		return;
	}
	if(productHasCustomLabel(product)) {
		const labelRef = labelOverride ? labelOverride.valuesToOverride.labelRef : product.options.label.labelRef;
		const labelObject = store.getters.tenantSettings.labels.find(b => b.key === labelRef);
		if(!labelObject) {
			return false;
		}
		const labelStyle = labelObject.styles.find(style => style.channels.includes(appConfig.channelAlias()));
		if(labelStyle && labelStyle.type === "bow") {
			return true;
		}
	}
	return false;
};
export const addProductToFavourite = async (product) => {
	if(!checkIsProductFavorite(product)) {
		await store.dispatch(mutationTypes.ADD_FAVORITE_PRODUCT, { productId: product.id, productTenantId: product.tenantId });
	} else {
		await store.dispatch(mutationTypes.REMOVE_FAVORITE_PRODUCT, {productId: product.id, productTenantId: product.tenantId });
	}
};

export const checkIsProductFavorite = (product) => {
	if(store.getters.favoriteProducts && store.getters.favoriteProducts.length > 0) {
		return !!store.getters.favoriteProducts.find(item => item.productId === product.id);
	}
};

export const hasNutritionalInformation = (product) => {
	return product.additionalInformation.longDescription || product.additionalInformation.allergens || product.additionalInformation.nutritional;
};
export const productHasDiscountLabel = (product) => {
	return product.discount
		&& product.discount.options.productLabel
		&& (
			!product.discount.options.deliveryMethods
			|| product.discount.options.deliveryMethods.length === 0
			|| product.discount.options.deliveryMethods.includes(store.getters.tenantSpecificData.deliveryChoice)
		)
		&& !productHasCustomLabel(product);
};

export const productHasDiscountLabelWithLongText = (product) => {
	return product.discount.options.productLabel.length > 6;
};

export const productHasNewLabel = (product) => {
	return product.discount
	&& product.discount.options.productLabel
	&& !productHasCustomLabel(product);
};
export const productHasBadges = (product) => {
	return product.options && product.options.productBadges && product.options.productBadges.length;
};
export const getProductBadges = (product) => {
	if(productHasBadges(product)) {
		const tenantBadges = store.getters.tenantSettings.productBadges;
		const validBadgesList = product.options.productBadges.filter(badge => isProductBadgeIdValid(badge));
		return validBadgesList.map(badge => tenantBadges.find(b => b.id === badge));
	}
	return [];
};
export default {
	getUnconfirmedDepartments: function(orderDptIds,order, dpts, confirmedDpts) {
		return orderDptIds.map(deptId => {
			const dept = dpts.find(dpt => dpt.id === deptId);
			const confirmation = confirmedDpts.find(dpt => dpt.departmentId === deptId);
			return {
				name: dept ? dept.name : "",
				confirmed: confirmation !== undefined
			};
		});
	}
};

export const getProductCatalogByVersionsFormatted = () => {
	const selectedVersion = store.getters.selectedVersion;
	if (selectedVersion && selectedVersion !== store.getters.activeVersion) {
		if (!store.getters.productCatalogByVersions[selectedVersion]) {
			return {};
		}

		const enrichedProductCatalog = store.getters.productCatalogByVersions[selectedVersion];

		const currentDate = TimeBox.now()
			.convertTimezones(getUserTimeZone())
			.convertTimezones(self.pickupTimeZone)
			.format(TimeBoxFormats.YYYY_MM_DD).exec();

		return new ProductCatalog({
			products: enrichedProductCatalog.products,
			categories: enrichedProductCatalog.categories,
			departments: enrichedProductCatalog.departments,
			priceRules: store.getters.priceRules,
			selectedShopId: null,
			pickupTimeZone: store.getters.pickupTimeZone,
			userTimeZone: getUserTimeZone(),
			currentDate: currentDate
		});
	}
	return store.getters.productCatalog;
};

export const filterItemsByPage = (items, pageNumber, pageSize) => {
	const startIndex = pageNumber * pageSize;
	const endIndex = startIndex + pageSize;
	return items.slice(startIndex, endIndex);
};

const groupNameRules = {
	[appConfig.businessModelsEnum.bm2.id]: {

	},
	[appConfig.businessModelsEnum.bm6.id]: {
		"checklist": {
			"2": "Side dishes",
			"3": "Drinks"
		}
	},
	[appConfig.businessModelsEnum.bm100.id]: {
		"single": "Main",
		"radiobuttons": "Breads",
		"amount": "Dips",
		"checklist": {
			"additions": "Additions",
			"fries": "Fries",
			"drinks": "Drinks"
		}
	},
	default: {
		"groupName": "N/A"
	}
};

export const getGroupNameWithRules = (group) => {
	let groupKey = "groupName";
	if([appConfig.businessModelsEnum.bm6.id, appConfig.businessModelsEnum.bm100.id].includes(appConfig.getBusinessModelId())) {
		groupKey = group.appearance;
		if(group.appearance === "checklist") {
			const subKey = appConfig.getBusinessModelId() === appConfig.businessModelsEnum.bm6.id ? group.options.position : group.options.groupType;
			return groupNameRules[appConfig.getBusinessModelId()][groupKey][subKey];
		}
		return groupNameRules[appConfig.getBusinessModelId()][groupKey];
	}
	return group.name;
};

export const getVersion = () => {
	return sessionStorage.getItem("version");
};

export const isCrossSellHighlightedItem = (crossSellProductToHighlight, productId) => {
	return crossSellProductToHighlight && crossSellProductToHighlight.highlightProductId  === productId;
};
